import { useHref } from 'react-router-dom';

/**
 *  Provides a clean basename for path construction, avoiding double slashes.
 *  Returns empty string for root basename ('/') to prevent '//' issues when concatenating paths.
 * @returns sanitized basename
 */
export const useGetBasename = () => {
    const basename = useHref('/');

    const sanitizedBasename = basename === '/' ? '' : basename;

    return sanitizedBasename;
};
